import type { Severity } from "../audit-data";
import { SEVERITY_LABELS } from "../audit-data";
import { createSeverityBadge as createUiSeverityBadge } from "../../ui/severity-badge";

// 重大度は色 + テキスト両方で表す(WCAG2)。tone / 並び順は共有 ui/severity-badge に集約し、
// 文言だけ SF の用語(critical =「重大」)を渡す。
export function createSeverityBadge(severity: Severity): HTMLElement {
  return createUiSeverityBadge({ severity, label: SEVERITY_LABELS[severity] });
}
